import { render, staticRenderFns } from "./PortalService.vue?vue&type=template&id=7edd1c73&"
import script from "./PortalService.vue?vue&type=script&lang=js&"
export * from "./PortalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports